import React, { useEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import { useModuleContext } from 'context/ModuleProvider';
import './Slider.css';
import moment from 'moment';
import axiosInstance from '../../axiosapi';

const isMobile = window.innerWidth <= 768;

const Slider = () => {
  let { url } = useModuleContext();
  const [sliderData, setSliderData] = useState([]);

  useEffect(() => {
    const fetchSlider = async () => {
      const fetchSlider = await axiosInstance.get(`${url}/notices?type=SLIDER`);
      setSliderData(fetchSlider.data.data);
    };
    fetchSlider();
  }, []);

  return (
    <div id="carouselSliders" className="carousel slide bg-white" data-ride="carousel">
      <ol className="carousel-indicators">
        {sliderData.map((slider, index) => (
          <li
            key={index}
            data-target="#carouselSliders"
            data-slide-to={index}
            className={index === 0 ? 'active' : ''}
          />
        ))}
      </ol>
      <div className="carousel-inner" style={{ height: isMobile ? '200px' : '450px' }}>
        {sliderData.map((slider, index) => (
          <div key={index} className={`carousel-item ${index === 0 ? 'active' : ''} h-100`}>
            <div className="clearfix text-right h-100">
              <p className="text-muted small">
                <i className="far fa-calendar-alt" />
                &nbsp;{moment(slider.created_at).format('MMM DD YYYY, dddd')}
              </p>
              <div className="slider__image d-flex justify-content-center align-items-center h-100">
                {!slider.videoUrl ? (
                  <img src={slider.image} alt="study" className="carousel-image img-fluid h-100 w-100" />
                ) : (
                  <ReactPlayer
                    controls
                    url={slider.videoUrl}
                    light={
                      <img
                        className="carousel-image img-fluid h-100 w-100"
                        src={slider.image}
                        alt="Thumbnail"
                        onError={({ currentTarget }) => {
                          currentTarget.onerror = null;
                          currentTarget.src = '/images/defaultthumbnail.jpg';
                        }}
                      />
                    }
                    style={{ height: '100%', objectFit: 'contain' }}
                    height="100%"
                    width="100%"
                  />
                )}
              </div>
            </div>
          </div>
        ))}
        <a
          href="#carouselSliders"
          role="button"
          data-slide="next"
          style={{ position: 'absolute', top: '50%', right: '20px' }}
        >
          <span className="carousel-control-next-icon" aria-hidden="true" />
          <span className="sr-only">Next</span>
        </a>
      </div>
    </div>
  );
};

export default Slider;
